jQuery(document).ready(function() {

class CaseStudyFilterButtons {
    constructor(containerId) {
        this.containerId = containerId;
        this.$filterButtonsContainer = jQuery(`.mad-filter-buttons__container[data-case-studies-id='${this.containerId}']`);
        this.$filterButtons = this.$filterButtonsContainer.find('.mad-filter-buttons .filter-button');
        this.$caseStudyContainer = jQuery(`.mad-case-studies__container[data-case-studies-id='${this.containerId}']`);
        this.$caseStudyContent = this.$caseStudyContainer.find('.mad-case-studies');
        this.$paginationContainer = jQuery(`.mad-case-studies__pagination[data-case-studies-id='${this.containerId}']`);

        // Get configuration from data attributes
        this.useAjax = this.$caseStudyContainer.data('use-ajax') === true;
        this.pagination = this.$caseStudyContainer.data('pagination') === true;
        this.shortcodeAtts = this.$caseStudyContainer.data('shortcode-atts') || {};

        this.currentFilter = 'all';
        this.isLoading = false;

        this.init();
    }

    init() {
        this.$filterButtons.on('click', (event) => {
            event.preventDefault();
            const $button = jQuery(event.currentTarget);
            const filterValue = $button.data('filter');
            if (this.isLoading) return;
            this.$filterButtons.removeClass('active');
            $button.addClass('active');
            this.currentFilter = filterValue;
            if (this.useAjax) {
                this.loadContent(1, filterValue, false);
            } else {
                this.filterItems(filterValue);
            }
        });

        this.$caseStudyContainer.on('click', '.mad-case-studies__pagination-button', (event) => {
            event.preventDefault();
            if (this.isLoading || !this.useAjax) return;
            const $button = jQuery(event.currentTarget);
            const page = parseInt($button.data('page'));
            if (page && page > 0) {
                this.loadContent(page, this.currentFilter, true);
            }
        });

        this.bindLoadMore();

        // Initial Load More button rendering
        if (this.shortcodeAtts && (this.shortcodeAtts.load_more === true || this.shortcodeAtts.load_more === 'true')) {
            const current = parseInt(this.$caseStudyContainer.data('current-page'), 10) || 1;
            const total = parseInt(this.$caseStudyContainer.data('total-pages'), 10) || 1;
            if (current < total) {
                this.updateLoadMoreUI({ has_more: true, current_page: current, next_page: current + 1 });
            } else {
                this.updateLoadMoreUI({ has_more: false, current_page: current });
            }
        }
    }

    filterItems(filterValue) {
        const $items = this.$caseStudyContent.find('.mad-case-studies__case-study-container');
        if (filterValue === 'all') {
            $items.removeClass('disabled');
        } else {
            $items.addClass('disabled');
            $items.filter(function() {
                const $item = jQuery(this);
                const keywords = $item.data('keywords').split(' ');
                return keywords.includes(filterValue);
            }).removeClass('disabled');
        }
    }

    loadContent(page = 1, filterTerm = 'all', isPagination = false) {
        if (this.isLoading) return;
        this.setLoadingState(true);
        const data = {
            action: window.$madSettings.caseStudies.action,
            nonce: window.$madSettings.caseStudies.nonce,
            page: page,
            filter_term: filterTerm,
            container_id: this.containerId,
            shortcode_atts: JSON.stringify(this.shortcodeAtts)
        };
        jQuery.ajax({
            url: window.$madSettings.caseStudies.ajaxurl,
            type: 'POST',
            data: data,
            timeout: 30000,
            success: (response) => {
                if (response.success) {
                    this.$caseStudyContent.html(response.html);
                    if (this.pagination) {
                        this.$paginationContainer.html(response.pagination_html || '');
                    }
                    if (this.shortcodeAtts && (this.shortcodeAtts.load_more === true || this.shortcodeAtts.load_more === 'true')) {
                        this.updateLoadMoreUI(response);
                    }
                    // Trigger lazy loading for newly loaded images
                    if (typeof window.madLazyBackgroundImage !== 'undefined') {
                        window.madLazyBackgroundImage.observe(this.$caseStudyContent[0]);
                    }
                    this.$caseStudyContainer.trigger('caseStudiesLoaded', [response]);
                    if (isPagination && typeof window.madScrollTo === 'function') {
                        window.madScrollTo(this.$caseStudyContainer);
                    }
                }
            },
            error: (xhr, status, error) => {
                console.error('AJAX Error:', error);
            },
            complete: () => {
                this.setLoadingState(false);
            }
        });
    }

    bindLoadMore() {
        jQuery(document).on('click', '.mad-case-studies__load-more-btn', (event) => {
            event.preventDefault();
            if (this.isLoading) return;
            const $btn = jQuery(event.currentTarget);
            const nextPage = parseInt($btn.data('next-page'));
            const uniqueId = $btn.data('unique-id');
            if (uniqueId !== this.containerId) return;
            const shortcodeAtts = Object.assign({}, this.shortcodeAtts, { current_page: nextPage, load_more: 'true' });
            this.setLoadingState(true);
            jQuery.ajax({
                url: window.$madSettings.caseStudies.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: window.$madSettings.caseStudies.action,
                    nonce: window.$madSettings.caseStudies.nonce,
                    page: nextPage,
                    filter_term: this.currentFilter || 'all',
                    shortcode_atts: JSON.stringify(shortcodeAtts),
                    container_id: uniqueId
                },
                beforeSend: function() {
                    $btn.prop('disabled', true).addClass('loading');
                },
                success: (response) => {
                    if (response.success && response.html) {
                        this.findLoadMoreWrapper().remove();
                        const $html = jQuery('<div>').html(response.html);
                        const $newItems = $html.find('.mad-case-studies__case-study-container');
                        const existingIds = new Set(this.$caseStudyContent.find('.mad-case-studies__case-study-container').map(function() {
                            return jQuery(this).data('post-id');
                        }).get());
                        $newItems.each((_, el) => {
                            const pid = jQuery(el).data('post-id');
                            if (!existingIds.has(pid)) {
                                this.$caseStudyContent.append(el);
                                existingIds.add(pid);
                            }
                        });
                        // Trigger lazy loading for newly appended images
                        if (typeof window.madLazyBackgroundImage !== 'undefined') {
                            window.madLazyBackgroundImage.observe(this.$caseStudyContent[0]);
                        }
                        if (this.shortcodeAtts && (this.shortcodeAtts.load_more === true || this.shortcodeAtts.load_more === 'true')) {
                            this.updateLoadMoreUI(response);
                        }
                    }
                },
                complete: function() {
                    $btn.prop('disabled', false).removeClass('loading');
                    this.setLoadingState(false);
                }.bind(this)
            });
        });
    }

    findLoadMoreWrapper() {
        return jQuery(`.mad-case-studies__load-more-wrapper[data-case-studies-id='${this.containerId}']`);
    }

    updateLoadMoreUI(response) {
        this.findLoadMoreWrapper().remove();
        const hasMore = !!response.has_more;
        if (!hasMore) {
            return;
        }
        const nextPage = parseInt(response.next_page, 10) || ((parseInt(response.current_page, 10) || 1) + 1);
        const loadMoreText = window.$madSettings.caseStudies.loadMoreText || 'Mehr anzeigen';
        const $wrapper = jQuery(
            `<div class="mad-case-studies__load-more-wrapper" data-case-studies-id="${this.containerId}">
                <button type="button" class="mad-button mad-button1 mad-case-studies__load-more-btn" data-next-page="${nextPage}" data-unique-id="${this.containerId}">
                    <span>${loadMoreText}</span>
                </button>
            </div>`
        );
        this.$caseStudyContainer.after($wrapper);
    }

    setLoadingState(isLoading) {
        this.isLoading = isLoading;
    }
}


    jQuery('.mad-filter-buttons__container').each(function() {
        const containerId = jQuery(this).data('case-studies-id');
        new CaseStudyFilterButtons(containerId);
    });
});
